const PIECE_OF_URL = 'cc/cheque-especial/v1/bff'

export const FREQUENT_QUESTIONS = `${PIECE_OF_URL}/faq`
export const OVERDRAFT_DETAILS = `${PIECE_OF_URL}/contrato`
export const CONTRACT_INFORMATION = `${PIECE_OF_URL}/contrato/oferta`
export const OVERDRAFT_CANCEL_DETAILS = `${PIECE_OF_URL}/contrato/cancelar`
export const DOCUMENTO_DESCRIPTIVE_CREDIT = `${PIECE_OF_URL}/contrato/documento-descritivo`
